var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperatives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 627,
    height: 348,
    viewBox: "0 0 627 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.000915527 223.37C-0.0065918 232.824 1.25677 242.233 3.75525 251.331C6.16998 260.102 9.72241 268.498 14.3167 276.293C14.3167 304.536 32.8527 328.945 59.7578 340.558C71.0004 345.362 83.0606 347.815 95.2347 347.774H507.975C530.035 347.774 550.478 341.652 567.244 331.223C572.042 328.252 576.594 324.878 580.853 321.137C599.487 304.665 611.041 281.902 611.041 256.76C621.499 240.196 627.045 220.859 627.001 201.109C627.001 159.754 603.22 124.194 569.151 108.494C564.627 106.41 559.953 104.691 555.17 103.353C553.478 102.879 551.768 102.455 550.04 102.079C545.433 101.07 540.76 100.41 536.058 100.106C534.359 99.9967 532.651 99.9347 530.934 99.9197H529.991C528.095 99.9197 526.215 99.9873 524.346 100.1L523.732 99.029C522.979 97.7362 522.208 96.4565 521.419 95.19C519.994 92.8825 518.5 90.6088 516.936 88.3689C515.299 86.005 513.591 83.6787 511.811 81.39L511.357 80.8262C510.348 79.5334 509.318 78.2556 508.265 76.9929C504.977 73.0506 501.506 69.2266 497.852 65.521C458.33 25.6768 396.414 0.0272217 326.808 0.0272217C272.647 0.0272217 223.139 15.5579 185.218 41.2188C170.852 32.8568 154.623 28.4691 138.116 28.4842C84.5472 28.4842 41.1067 73.7909 41.1067 129.679C41.1146 133.215 41.2975 136.749 41.6547 140.266C28.7419 149.667 18.2167 162.126 10.9673 176.589C3.71777 191.053 -0.043457 207.098 0.000915527 223.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M497.84 65.4938V76.9656H508.254C504.991 73.027 501.52 69.2031 497.84 65.4938Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M478.729 62.585H492.71V76.9657H478.729V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.623 62.585H473.604V76.9657H459.623V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M440.511 62.585H454.492V76.9657H440.511V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.405 62.585H435.387V76.9657H421.405V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 62.585H416.275V76.9657H402.294V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.183 62.585H397.164V76.9657H383.183V62.585Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.077 62.585H378.059V76.9657H364.077V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 62.585H358.946V76.9657H344.965V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.859 62.585H339.841V76.9657H325.859V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 62.585H320.729V76.9657H306.747V62.585Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.637 62.585H301.618V76.9657H287.637V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.53 62.585H282.512V76.9657H268.53V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 62.585H263.4V76.9657H249.419V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.308 62.585H244.289V76.9657H230.308V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.201 62.585H225.183V76.9657H211.201V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 62.585H206.071V76.9657H192.09V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.984 62.585H186.966V76.9657H172.984V62.585Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.873 62.585H167.854V76.9657H153.873V62.585Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 62.585H148.742V76.9657H134.761V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.655 62.585H129.637V76.9657H115.655V62.585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5439 62.585H110.525V76.9657H96.5439V62.585Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4384 62.585H91.4199V76.9657H77.4384V62.585Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.946 88.3585V95.1796H521.43C520.005 92.8571 518.51 90.5834 516.946 88.3585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M497.841 80.799H511.822V95.1796H497.841V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.729 80.799H492.71V95.1796H478.729V80.799Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.623 80.799H473.604V95.1796H459.623V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 80.799H454.492V95.1796H440.511V80.799Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.405 80.799H435.387V95.1796H421.405V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M402.294 80.799H416.275V95.1796H402.294V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.183 80.799H397.164V95.1796H383.183V80.799Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M364.077 80.799H378.059V95.1796H364.077V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 80.799H358.946V95.1796H344.965V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M325.859 80.799H339.841V95.1796H325.859V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 80.799H320.729V95.1796H306.747V80.799Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M287.637 80.799H301.618V95.1796H287.637V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M268.53 80.799H282.512V95.1796H268.53V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 80.799H263.4V95.1796H249.419V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.308 80.799H244.289V95.1796H230.308V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.201 80.799H225.183V95.1796H211.201V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 80.799H206.071V95.1796H192.09V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 80.799H186.966V95.1796H172.984V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.873 80.799H167.854V95.1796H153.873V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 80.799H148.742V95.1796H134.761V80.799Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.655 80.799H129.637V95.1796H115.655V80.799Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5439 80.799H110.525V95.1796H96.5439V80.799Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4384 80.799H91.4199V95.1796H77.4384V80.799Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.169 103.348V113.399H569.15V108.489C564.626 106.405 559.952 104.687 555.169 103.348Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.058 100.101V113.399H550.039V102.074L536.058 100.101Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.951 99.0187H530.933V113.399H516.951V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M497.841 99.0187H511.822V113.399H497.841V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.729 99.0187H492.71V113.399H478.729V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M459.623 99.0187H473.604V113.399H459.623V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 99.0187H454.492V113.399H440.511V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.405 99.0187H435.387V113.399H421.405V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M402.294 99.0187H416.275V113.399H402.294V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.183 99.0187H397.164V113.399H383.183V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 99.0187H378.059V113.399H364.077V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 99.0187H358.946V113.399H344.965V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M325.859 99.0187H339.841V113.399H325.859V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 99.0187H320.729V113.399H306.747V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.637 99.0187H301.618V113.399H287.637V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M268.53 99.0187H282.512V113.399H268.53V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 99.0187H263.4V113.399H249.419V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.308 99.0187H244.289V113.399H230.308V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.201 99.0187H225.183V113.399H211.201V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M192.09 99.0187H206.071V113.399H192.09V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M172.984 99.0187H186.966V113.399H172.984V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.873 99.0187H167.854V113.399H153.873V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 99.0187H148.742V113.399H134.761V99.0187Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.655 99.0187H129.637V113.399H115.655V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5439 99.0187H110.525V113.399H96.5439V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4384 99.0187H91.4199V113.399H77.4384V99.0187Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.169 117.233H569.15V131.613H555.169V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.058 117.233H550.039V131.613H536.058V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M516.951 117.233H530.933V131.613H516.951V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M497.841 117.233H511.822V131.613H497.841V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.729 117.233H492.71V131.613H478.729V117.233Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M459.623 117.233H473.604V131.613H459.623V117.233Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 117.233H454.492V131.613H440.511V117.233Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.405 117.233H435.387V131.613H421.405V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 117.233H416.275V131.613H402.294V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.183 117.233H397.164V131.613H383.183V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M364.077 117.233H378.059V131.613H364.077V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.965 117.233H358.946V131.613H344.965V117.233Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.859 117.233H339.841V131.613H325.859V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M306.747 117.233H320.729V131.613H306.747V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M287.637 117.233H301.618V131.613H287.637V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M268.53 117.233H282.512V131.613H268.53V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249.419 117.233H263.4V131.613H249.419V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.308 117.233H244.289V131.613H230.308V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.201 117.233H225.183V131.613H211.201V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 117.233H206.071V131.613H192.09V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 117.233H186.966V131.613H172.984V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M153.873 117.233H167.854V131.613H153.873V117.233Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M134.761 117.233H148.742V131.613H134.761V117.233Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.655 117.233H129.637V131.613H115.655V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.5439 117.233H110.525V131.613H96.5439V117.233Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4384 117.233H91.4199V131.613H77.4384V117.233Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.169 135.452H569.15V149.833H555.169V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.058 135.452H550.039V149.833H536.058V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M516.951 135.452H530.933V149.833H516.951V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M497.841 135.452H511.822V149.833H497.841V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M478.729 135.452H492.71V149.833H478.729V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M459.623 135.452H473.604V149.833H459.623V135.452Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 135.452H454.492V149.833H440.511V135.452Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.405 135.452H435.387V149.833H421.405V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 135.452H416.275V149.833H402.294V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.183 135.452H397.164V149.833H383.183V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 135.452H378.059V149.833H364.077V135.452Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 135.452H358.946V149.833H344.965V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.859 135.452H339.841V149.833H325.859V135.452Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 135.452H320.729V149.833H306.747V135.452Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.637 135.452H301.618V149.833H287.637V135.452Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.53 135.452H282.512V149.833H268.53V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.419 135.452H263.4V149.833H249.419V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.308 135.452H244.289V149.833H230.308V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.201 135.452H225.183V149.833H211.201V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 135.452H206.071V149.833H192.09V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 135.452H186.966V149.833H172.984V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.873 135.452H167.854V149.833H153.873V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M134.761 135.452H148.742V149.833H134.761V135.452Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.655 135.452H129.637V149.833H115.655V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.5439 135.452H110.525V149.833H96.5439V135.452Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4384 135.452H91.4199V149.833H77.4384V135.452Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.169 153.666H569.15V168.047H555.169V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M536.058 153.666H550.039V168.047H536.058V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M516.951 153.666H530.933V168.047H516.951V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M497.841 153.666H511.822V168.047H497.841V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M478.729 153.666H492.71V168.047H478.729V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.623 153.666H473.604V168.047H459.623V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.511 153.666H454.492V168.047H440.511V153.666Z",
    fill: "#112EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.405 153.666H435.387V168.047H421.405V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 153.666H416.275V168.047H402.294V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.183 153.666H397.164V168.047H383.183V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.077 153.666H378.059V168.047H364.077V153.666Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.965 153.666H358.946V168.047H344.965V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.859 153.666H339.841V168.047H325.859V153.666Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 153.666H320.729V168.047H306.747V153.666Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.637 153.666H301.618V168.047H287.637V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.53 153.666H282.512V168.047H268.53V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 153.666H263.4V168.047H249.419V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.308 153.666H244.289V168.047H230.308V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.201 153.666H225.183V168.047H211.201V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 153.666H206.071V168.047H192.09V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 153.666H186.966V168.047H172.984V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.873 153.666H167.854V168.047H153.873V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 153.666H148.742V168.047H134.761V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.655 153.666H129.637V168.047H115.655V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M96.5439 153.666H110.525V168.047H96.5439V153.666Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4384 153.666H91.4199V168.047H77.4384V153.666Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M555.169 171.886H569.15V186.267H555.169V171.886Z",
    fill: "#112EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M536.058 171.886H550.039V186.267H536.058V171.886Z",
    fill: "#112EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M516.951 171.886H530.933V186.267H516.951V171.886Z",
    fill: "#112EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M497.841 171.886H511.822V186.267H497.841V171.886Z",
    fill: "#112EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M478.729 171.886H492.71V186.267H478.729V171.886Z",
    fill: "#112EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M459.623 171.886H473.604V186.267H459.623V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M440.511 171.886H454.492V186.267H440.511V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M421.405 171.886H435.387V186.267H421.405V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.294 171.886H416.275V186.267H402.294V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.183 171.886H397.164V186.267H383.183V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.077 171.886H378.059V186.267H364.077V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.965 171.886H358.946V186.267H344.965V171.886Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.859 171.886H339.841V186.267H325.859V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M306.747 171.886H320.729V186.267H306.747V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.637 171.886H301.618V186.267H287.637V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.53 171.886H282.512V186.267H268.53V171.886Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.419 171.886H263.4V186.267H249.419V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.308 171.886H244.289V186.267H230.308V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.201 171.886H225.183V186.267H211.201V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.09 171.886H206.071V186.267H192.09V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.984 171.886H186.966V186.267H172.984V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.873 171.886H167.854V186.267H153.873V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.761 171.886H148.742V186.267H134.761V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.655 171.886H129.637V186.267H115.655V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.5439 171.886H110.525V186.267H96.5439V171.886Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4384 171.886H91.4199V186.267H77.4384V171.886Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.427 224.792C213.872 224.792 205.315 215.991 205.315 205.135C205.315 194.278 213.872 185.478 224.427 185.478C234.982 185.478 243.538 194.278 243.538 205.135C243.538 215.991 234.982 224.792 224.427 224.792Z",
    fill: "#767D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.419 180.128C223.511 188.689 221.893 197.314 220.563 206.003C220.163 208.585 219.806 211.307 220.716 213.748C221.478 215.783 223.029 217.373 224.246 219.155C225.462 220.936 226.383 223.219 225.643 225.26C224.903 227.3 222.744 228.417 220.683 228.992C214.786 230.626 208.499 229.437 202.63 227.667C199.972 226.963 197.424 225.878 195.061 224.442C192.572 222.819 190.534 220.564 188.659 218.241C180.104 207.57 174.502 194.762 169.23 182.033C172.618 182.35 176.03 181.834 179.186 180.526C182.341 179.218 185.149 177.157 187.377 174.513C189.536 171.903 191.12 168.267 189.903 165.076C193.471 167.089 197.708 167.224 201.55 168.599C203.933 169.535 206.226 170.696 208.401 172.066C211.024 173.626 213.633 175.216 216.227 176.836C219.192 178.673 221.971 180.308 225.419 180.128Z",
    fill: "#AE6E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.448 194.886C188.797 201.589 193.154 208.032 199.375 212.023C205.595 216.015 213.97 217.097 220.201 213.151C223.271 211.223 225.594 208.292 228.275 205.822C230.955 203.353 234.303 201.239 237.904 201.561C241.872 201.916 244.98 205.101 247.638 208.151C251.672 212.785 255.569 217.616 258.424 223.101C263.905 233.642 265.204 245.965 264.963 257.916C264.722 269.867 263.039 281.756 263.001 293.707C262.946 308.41 265.368 322.993 267.818 337.475C245.292 334.623 222.739 340.858 200.164 343.22C185.716 344.747 171.159 344.714 156.635 344.674C154.081 344.674 151.363 344.606 149.236 343.152C147.937 342.177 146.885 340.892 146.173 339.409C144.167 335.604 143.361 331.263 142.802 326.973C141.382 316.138 141.339 305.168 141.3 294.232C141.202 267.737 141.108 241.146 144.38 214.859C145.186 208.393 146.217 201.893 148.628 195.845C151.04 189.796 154.975 184.232 160.477 180.99C164.013 178.905 172.206 175.274 176.372 177.377C181.047 179.722 183.206 190.399 185.448 194.886Z",
    fill: "#767D9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.781 269.704C184.631 253.356 188.089 235.908 180.728 221.398C178.92 217.835 185.409 213.388 183.403 209.938C180.955 205.731 179.099 201.189 177.889 196.448C177.473 194.818 177.138 193.093 177.533 191.459C178.262 188.476 181.128 186.701 183.562 184.886C186.247 182.879 187.629 176.762 188.495 173.453C189.36 170.144 181.605 174.13 178.487 172.951C174.157 171.322 168.654 172.348 164.335 174C161.924 174.913 159.304 174.992 156.733 175.06C151.74 175.195 146.731 175.325 141.776 174.693C139.551 174.406 137.321 173.972 135.084 174.101C129.379 174.434 124.419 178.448 121.043 183.194C117.666 187.941 115.518 193.471 112.75 198.612C110.443 202.897 107.691 206.944 105.724 211.403C103.981 215.349 102.879 219.589 101.789 223.805L98.9771 234.623C98.4852 236.171 98.2517 237.793 98.2865 239.42C98.429 241.151 99.1744 242.763 99.9307 244.302C102.791 250.006 106.22 255.389 110.163 260.363C116.077 267.821 123.257 274.546 126.77 283.476C128.14 286.954 128.902 290.652 129.598 294.339C132.405 309.084 134.399 323.981 135.572 338.958C141.976 335.91 148.689 333.601 155.588 332.075C159.027 331.318 162.503 330.753 166.001 330.383C169.065 330.057 173.017 330.677 175.933 329.82C180.81 328.394 181.348 319.909 182.087 315.467C183.271 308.392 183.507 301.194 183.551 294.046C183.606 285.917 183.359 277.805 183.781 269.704Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.903 239.133C288.596 252.662 286.053 266.231 281.038 278.943C281.164 279.067 281.29 279.18 281.416 279.293C281.86 279.682 282.32 280.048 282.803 280.42C283.926 281.232 285.159 281.92 286.091 282.98C286.444 283.385 286.722 283.853 286.913 284.361C287.085 284.757 287.174 285.187 287.174 285.621C287.174 286.055 287.085 286.484 286.913 286.881C289.528 288.07 292.564 287.704 295.496 287.591C298.023 287.495 300.473 287.591 302.501 289.017C305.318 291.013 306.167 294.846 306.622 298.33C306.79 299.6 306.934 300.872 307.055 302.146C307.172 303.33 307.267 304.518 307.34 305.709C307.588 309.65 307.623 313.602 307.444 317.547C307.415 318.269 307.377 318.991 307.329 319.712C316.285 319.492 324.446 314.689 332.168 310.022C333.933 308.956 335.752 307.834 336.898 306.076C337.953 304.348 338.4 302.3 338.164 300.275C338.164 299.987 338.115 299.711 338.076 299.418C337.831 297.745 337.41 296.104 336.821 294.525C334.405 287.796 330.844 281.564 326.303 276.119C324.341 273.763 322.133 271.457 321.217 268.498C320.817 267.207 320.669 265.837 320.264 264.551C318.444 258.982 311.878 256.349 309.631 250.943C309.083 249.652 308.831 248.237 308.151 246.997C307.539 245.966 306.75 245.059 305.822 244.319C305.422 243.975 305.005 243.643 304.594 243.31C300.743 240.206 297.033 236.927 293.463 233.473C292.798 232.831 292.14 232.18 291.49 231.523C291.577 234.074 291.38 236.627 290.903 239.133Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.673 199.12C236.462 199.976 237.317 200.783 238.156 201.583L238.381 201.792L239.269 202.637C240.88 204.068 242.275 205.738 243.407 207.592L243.5 207.75C246.295 212.897 245.259 219.233 244.481 225.079C243.516 232.364 243.081 239.713 243.182 247.065C243.324 257.212 244.486 267.291 244.508 277.427C244.508 279.727 244.459 282.021 244.36 284.321C244.201 288.059 243.927 291.791 243.598 295.523C243.242 299.615 242.815 303.702 242.415 307.789C242.097 310.952 241.795 314.109 241.543 317.265C241.417 318.9 241.297 320.529 241.198 322.164C241.083 324.081 240.99 326.003 240.935 327.92C240.896 329.138 240.874 330.35 240.874 331.567C240.874 332.261 240.874 332.948 240.874 333.636C240.874 334.955 240.909 336.271 240.979 337.582C241.052 339.27 241.163 340.961 241.313 342.656C241.483 344.499 241.784 346.512 243.045 347.808C243.122 347.887 243.204 347.96 243.286 348.034L245.062 347.808C257.303 346.301 269.662 346.074 281.947 347.132C281.679 345.226 281.432 343.327 281.191 341.416C281.081 340.514 280.972 339.606 280.868 338.698C280.747 337.661 280.632 336.624 280.522 335.587C280.396 334.459 280.281 333.332 280.172 332.204C279.887 329.299 279.636 326.392 279.421 323.483C279.103 319.24 278.862 314.99 278.697 310.732C278.617 308.699 278.555 306.664 278.511 304.627C278.449 302.101 278.42 299.574 278.423 297.045C278.423 294.587 278.443 292.125 278.483 289.66C278.483 288.848 278.516 288.036 278.582 287.23C278.629 286.504 278.726 285.783 278.873 285.071C279.28 283.43 279.83 281.83 280.517 280.291C280.637 279.997 280.753 279.727 280.868 279.417C280.933 279.265 280.994 279.107 281.054 278.955C277.897 276.063 275.65 272.19 273.491 268.379C269.988 262.24 266.404 255.831 265.817 248.739C265.231 241.647 268.656 233.682 275.244 231.517C277.037 230.953 278.933 230.795 280.78 230.463C282.523 230.147 286.157 229.431 288.173 228.146C289.27 229.303 290.366 230.44 291.462 231.556C291.395 229.853 290.991 228.182 290.273 226.646L289.494 226.686C289.558 226.505 289.587 226.314 289.582 226.122C289.582 225.519 289.176 224.837 288.31 224.081C285.729 221.827 281.668 221.325 280.04 218.275C279.36 217.007 279.245 215.496 278.697 214.165C277.124 210.372 272.608 208.974 269.89 205.941C267.171 202.908 266.492 198.612 264.294 195.23C262.652 192.76 260.375 190.808 257.717 189.593C257.498 189.486 257.273 189.378 257.048 189.283C252.499 187.281 247.095 186.825 242.382 186.836C240.551 186.836 235.805 186.892 233.481 187.845C233.104 187.984 232.759 188.2 232.467 188.482C229.99 191.256 233.843 197.113 235.673 199.12Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.086 226.252C285.853 224.941 281.408 224.508 277.01 224.98C272.612 225.451 268.349 226.817 264.469 228.997C260.523 231.252 256.983 234.398 254.812 238.456C251.551 244.545 251.694 251.884 251.924 258.835C252.039 262.313 252.187 265.916 253.678 269.039C255.404 272.652 258.66 275.133 261.981 277.162C264.062 278.527 266.341 279.542 268.733 280.167C272.416 280.99 276.242 280.291 279.952 279.603C283.986 278.836 288.316 277.912 291.117 274.822C292.761 273.03 293.66 270.702 294.548 268.424C295.823 265.136 297.102 261.851 298.384 258.57C300.604 252.871 301.355 248.13 298.423 242.577C297.091 240.046 295.463 237.679 294.148 235.13C293.49 233.834 291.133 226.584 290.086 226.252Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7404 323.703V340.559C70.9831 345.363 83.0433 347.816 95.2174 347.774H243.028C243.105 347.853 243.187 347.927 243.269 348L245.045 347.774H507.974C530.034 347.774 550.477 341.652 567.243 331.223V305.489L440.791 290.477H440.692L367.053 296.893L347.996 298.584L338.098 299.446L317.611 301.233L307.071 302.152L291.725 303.494L289.565 303.68L278.505 304.644L263.499 305.912L242.398 307.75L207.222 310.822L182.477 312.981L141.842 316.527L134.114 317.198L133.281 317.271L132.558 317.333L122.353 318.224L111.15 319.205L109.851 319.318L59.7404 323.703Z",
    fill: "#504F60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.27 323.083L366.741 295.263L372.885 327.221L300.243 336.167L277.876 339.048L216.349 326.584L208.27 323.083Z",
    fill: "#9C9CA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3 337.447L210.905 322.097C210.508 322.018 210.099 322.032 209.708 322.135C209.316 322.239 208.951 322.43 208.64 322.696C208.329 322.962 208.079 323.295 207.908 323.672C207.736 324.049 207.648 324.46 207.65 324.876C207.648 325.536 207.872 326.175 208.281 326.683C208.691 327.191 209.261 327.535 209.892 327.655L287.428 342.588L290.3 337.447Z",
    fill: "#9C9CA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.858 289.175C253.386 288.938 250.882 288.538 248.657 287.411C245.916 286.007 243.784 283.589 241.247 281.807C235.667 277.861 228.202 277.331 221.806 279.597C215.41 281.864 210.072 286.717 206.334 292.512C203.851 296.374 201.988 301.301 203.742 305.563C204.343 306.865 205.102 308.085 206 309.193L210.571 315.338C211.439 316.629 212.484 317.786 213.673 318.771C215.383 320.05 217.509 320.575 219.603 320.89C225.166 321.725 230.828 321.251 236.434 321.634C246.064 322.294 255.469 325.485 265.121 325.378C270.667 325.316 276.143 324.166 281.563 323.016L305.552 317.942C309.729 317.063 314.448 315.777 316.415 311.882C317.298 310.129 317.462 308.099 317.566 306.126C317.851 300.692 317.566 294.649 313.905 290.731C310.463 287.055 305.021 285.894 300.91 283.177C295.879 279.845 294.218 280.922 288.913 283.425C278.562 288.246 267.174 290.227 255.858 289.175Z",
    fill: "#AE6E79"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M255.858 289.175C253.386 288.938 250.882 288.538 248.657 287.411C245.916 286.007 243.784 283.589 241.247 281.807C235.667 277.861 228.202 277.331 221.806 279.597C215.41 281.864 210.072 286.717 206.334 292.512C203.851 296.374 201.988 301.301 203.742 305.563C204.343 306.865 205.102 308.085 206 309.193L210.571 315.338C211.439 316.629 212.484 317.786 213.673 318.771C215.383 320.05 217.509 320.575 219.603 320.89C225.166 321.725 230.828 321.251 236.434 321.634C246.064 322.294 255.469 325.485 265.121 325.378C270.667 325.316 276.143 324.166 281.563 323.016L305.552 317.942C309.729 317.063 314.448 315.777 316.415 311.882C317.298 310.129 317.462 308.099 317.566 306.126C317.851 300.692 317.566 294.649 313.905 290.731C310.463 287.055 305.021 285.894 300.91 283.177C295.879 279.845 294.218 280.922 288.913 283.425C278.562 288.246 267.174 290.227 255.858 289.175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.523 281.446C166.253 284.124 173.022 286.813 180.07 288.408C191.887 291.086 204.251 290.663 215.975 293.724C222.168 295.348 228.323 297.964 234.686 297.434C237.531 297.197 240.277 296.306 243.044 295.63C258.593 291.684 276.269 292.963 288.896 303.11C293.215 306.577 296.75 310.901 299.957 315.512C300.643 316.508 301.106 317.648 301.315 318.85C301.523 320.051 301.47 321.286 301.161 322.464C300.851 323.642 300.292 324.736 299.524 325.667C298.756 326.597 297.798 327.341 296.717 327.847C291.807 330.17 286.546 331.613 281.163 332.114C273.967 332.768 266.738 331.72 259.58 330.671C248.958 329.121 238.331 327.565 227.737 325.823C223.933 325.197 220.129 324.549 216.304 324.053C188.774 320.473 160.745 324.825 133.144 321.837C130.354 321.533 127.515 321.138 124.978 319.915C118.554 316.815 115.375 308.641 116.702 301.459C118.028 294.277 123.147 288.307 129.307 284.643C134.47 281.559 140.039 280.313 145.788 279.005C151.126 277.726 154.382 279.417 159.523 281.446Z",
    fill: "#AE6E79"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M100.479 238.513C97.4426 242.606 96.7959 248.096 97.1248 253.221C97.4536 258.345 98.6374 263.413 98.8128 268.56C99.054 275.618 97.3988 282.653 97.6783 289.688C97.8756 294.61 99.0101 299.435 100.353 304.159C101.937 309.734 104.228 315.727 109.232 318.404C115.874 321.962 129.807 319.96 136.795 322.745C136.159 318.669 130.064 312.767 129.428 308.691C128.99 305.873 128.546 302.975 129.017 300.151C129.62 296.549 131.676 293.352 134.114 290.692C137.995 286.458 143.059 283.273 148.622 282.236C154.185 281.198 167.805 282.05 172.255 285.663C172.803 281.931 162.609 278.335 159.025 277.529C157.238 277.117 155.188 277.348 153.758 276.181C151.017 273.972 153.007 269.569 152.875 266.034C152.771 263.216 151.171 260.634 150.847 257.815C150.299 253.305 153.16 248.711 152.037 244.286C151.62 242.651 150.694 241.213 150.053 239.657C148.101 234.894 148.956 229.46 149.998 224.397C150.644 221.218 151.275 217.633 149.554 214.921C147.959 212.39 143.432 221.404 140.532 220.987C130.958 219.606 122.292 212.305 114.559 218.281C110.618 221.325 110.103 224.482 108.53 228.828C107.001 232.966 103.039 235.086 100.479 238.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8344 238.513C95.7981 242.606 95.1513 248.096 95.4802 253.221C95.809 258.345 96.9928 263.413 97.1682 268.56C97.4094 275.617 95.7542 282.653 96.0337 289.688C96.231 294.609 97.3655 299.435 98.7083 304.159C100.292 309.734 102.583 315.727 107.587 318.404C114.23 321.961 128.162 319.96 135.15 322.745C134.514 318.669 128.42 312.767 127.784 308.691C127.345 305.873 126.901 302.975 127.373 300.151C127.976 296.549 130.031 293.352 132.47 290.692C136.35 286.458 141.414 283.273 146.977 282.236C152.54 281.198 166.16 282.05 170.611 285.663C171.159 281.931 160.964 278.335 157.38 277.529C155.593 277.117 153.543 277.348 152.113 276.181C149.373 273.971 151.362 269.569 151.231 266.034C151.126 263.215 149.526 260.634 149.203 257.815C148.655 253.305 151.516 248.711 150.392 244.286C149.975 242.651 149.049 241.213 148.408 239.657C146.457 234.894 147.312 229.46 148.353 224.397C149 221.218 149.63 217.633 147.909 214.921C146.314 212.39 143.196 211.432 140.296 211.009C130.589 209.658 120.753 212.268 112.893 218.281C108.952 221.325 108.437 224.482 106.864 228.828C105.356 232.966 101.394 235.085 98.8344 238.513Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.48 211.804L431.681 325.079C431.316 326.467 430.548 327.707 429.479 328.635C428.411 329.562 427.093 330.133 425.702 330.271L291.576 343.524C290.483 343.632 289.381 343.47 288.361 343.05C287.342 342.63 286.435 341.965 285.717 341.11C284.999 340.256 284.49 339.236 284.234 338.138C283.977 337.04 283.981 335.894 284.243 334.797L316.876 198.161C317.264 196.537 318.2 195.107 319.516 194.126C320.833 193.144 322.445 192.675 324.066 192.8L455.38 202.902C456.388 202.983 457.367 203.291 458.246 203.806C459.125 204.32 459.883 205.027 460.465 205.877C461.048 206.728 461.441 207.699 461.616 208.724C461.792 209.748 461.745 210.8 461.48 211.804Z",
    fill: "#9C9CA1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.669 266.917C382.643 268.494 382.394 271.557 380.197 272.739L346.541 290.845C344.1 292.158 341.146 290.203 341.372 287.423L341.753 282.712C341.848 281.541 342.525 280.503 343.554 279.949L359.104 271.584C361.928 270.064 362.248 266.126 359.711 264.099L345.742 252.936C344.818 252.198 344.32 251.05 344.415 249.878L344.796 245.168C345.022 242.388 348.245 241.017 350.438 242.768L380.669 266.917Z",
    stroke: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.66 267.522C391.775 269.211 391.508 272.493 389.154 273.759L355.499 291.864C352.884 293.271 349.72 291.176 349.961 288.198L350.342 283.486C350.444 282.231 351.168 281.119 352.271 280.526L367.82 272.161C370.488 270.726 370.79 267.007 368.394 265.092L354.424 253.929C353.435 253.138 352.9 251.907 353.002 250.652L353.384 245.942C353.625 242.963 357.079 241.494 359.428 243.371L389.66 267.522Z",
    stroke: "white",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.418 266.577C376.221 267.759 375.974 270.823 377.947 272.399L408.183 296.543C410.375 298.294 413.598 296.923 413.823 294.143L414.205 289.432C414.3 288.261 413.801 287.111 412.876 286.373L398.907 275.218C396.37 273.192 396.688 269.253 399.512 267.733L415.064 259.362C416.093 258.808 416.769 257.77 416.863 256.599L417.245 251.889C417.47 249.109 414.516 247.153 412.075 248.467L378.418 266.577Z",
    stroke: "url(#paint1_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.462 265.558C367.108 266.825 366.843 270.107 368.957 271.796L399.193 295.94C401.542 297.816 404.995 296.347 405.236 293.369L405.618 288.658C405.719 287.402 405.185 286.171 404.194 285.38L390.225 274.225C387.829 272.312 388.129 268.592 390.796 267.156L406.349 258.785C407.451 258.191 408.175 257.08 408.276 255.825L408.658 251.114C408.899 248.136 405.734 246.041 403.119 247.448L369.462 265.558Z",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M195.603 233.907C187.461 233.907 180.86 227.03 180.86 218.546C180.86 210.062 187.461 203.184 195.603 203.184C203.746 203.184 210.347 210.062 210.347 218.546C210.347 227.03 203.746 233.907 195.603 233.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.496 190.523C183.496 190.523 180.388 200.027 189.558 204.024L190.73 206.132L184.987 211.961C184.987 211.961 177.905 198.674 178.673 193.956C178.673 193.956 179.769 189.164 183.496 190.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.91 233.907C186.058 233.907 179.693 227.36 179.693 219.284C179.693 211.208 186.058 204.661 193.91 204.661C201.762 204.661 208.127 211.208 208.127 219.284C208.127 227.36 201.762 233.907 193.91 233.907Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.602 196.115L180.86 192.282L184.148 191.803C183.447 179.181 186.631 175.421 186.631 175.421L187.371 175.347L190.594 175.026L196.655 168.554V166.717C188.138 167.76 183.43 171.92 180.887 176.796C176.393 185.353 178.602 196.115 178.602 196.115Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.343 173.025V175.347L190.566 175.026L196.628 168.554C196.628 168.554 187.25 170.714 187.343 173.025Z",
    fill: "black",
    stroke: "#4C4981",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.602 196.115L180.86 192.282V176.819C176.394 185.354 178.602 196.115 178.602 196.115Z",
    fill: "black",
    stroke: "#4C4981",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.181 225.295C216.398 223.049 216.561 215.475 220.544 208.379C224.527 201.282 230.823 197.35 234.606 199.596C238.389 201.843 238.226 209.417 234.242 216.513C230.259 223.61 223.963 227.542 220.181 225.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.26 211.206C221.275 218.303 216.387 223.044 220.168 225.299C223.95 227.554 234.966 226.427 238.951 219.324C242.935 212.221 239.318 202.412 235.536 200.157C231.755 197.902 229.25 204.092 225.26 211.206Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M189.783 160.076C189.783 182.755 204.871 204.61 226.92 204.61C237.51 204.61 247.665 200.284 255.153 192.582C262.641 184.88 266.848 174.435 266.848 163.543C266.848 152.651 262.641 142.206 255.153 134.504C247.665 126.802 237.51 122.475 226.92 122.475C204.871 122.498 189.783 137.392 189.783 160.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.92 203.505C204.869 203.505 186.993 185.119 186.993 162.438C186.993 139.757 204.869 121.37 226.92 121.37C248.972 121.37 266.848 139.757 266.848 162.438C266.848 185.119 248.972 203.505 226.92 203.505Z",
    fill: "#AE6E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.428 144.241C225.677 146.039 222.865 151.09 218.601 153.903C212.572 157.849 204.724 156.829 197.84 154.878C194.003 153.802 189.991 152.488 186.215 153.683C185.66 153.936 185.047 154.026 184.445 153.943C183.623 153.7 183.217 152.764 182.949 151.93C178.279 137.611 180.378 121.393 187.426 108.145C189.246 104.729 191.427 101.426 194.431 99.0524C196.798 97.1865 199.583 95.9632 202.389 94.9203C207.517 93.0259 212.821 91.6791 218.217 90.9009C219.17 90.7229 220.143 90.6906 221.106 90.8051C222.426 91.025 223.61 91.7578 224.789 92.4117C229.836 95.1944 235.432 96.7579 241.154 96.9836C248.827 97.2823 257.597 95.422 263.51 100.484C270.635 106.556 268.86 118.4 273.48 126.641C276.538 132.092 282.435 136.05 283.406 142.257C283.658 144.154 283.541 146.083 283.06 147.933C280.802 157.483 271.814 164.879 262.233 165.054C260.762 165.169 259.289 164.859 257.98 164.157C257.123 163.556 256.366 162.815 255.739 161.964C249.463 154.32 242.283 139.754 230.428 144.241Z",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.948 147.775C183.216 148.61 183.622 149.546 184.444 149.788C185.046 149.871 185.659 149.782 186.214 149.529C189.99 148.334 194.024 149.647 197.833 150.724C204.723 152.674 212.588 153.717 218.595 149.748C222.864 146.93 225.67 141.856 230.428 140.086C242.282 135.576 249.462 150.166 255.754 157.81C256.382 158.66 257.138 159.401 257.996 160.003C259.304 160.704 260.778 161.014 262.249 160.899C271.796 160.724 280.79 153.328 283.076 143.779C283.202 143.215 283.312 142.651 283.394 142.087C283.394 142.138 283.394 142.183 283.421 142.234C283.674 144.131 283.556 146.061 283.076 147.911C280.818 157.46 271.824 164.856 262.249 165.031C260.778 165.147 259.304 164.836 257.996 164.135C257.138 163.533 256.382 162.792 255.754 161.942C249.462 154.298 242.282 139.731 230.428 144.218C225.67 146.017 222.864 151.068 218.595 153.881C212.566 157.827 204.723 156.806 197.833 154.856C193.997 153.779 189.99 152.466 186.214 153.661C185.659 153.914 185.046 154.003 184.444 153.92C183.622 153.678 183.216 152.742 182.948 151.908C181.064 146.049 180.232 139.887 180.492 133.722C180.654 138.503 181.48 143.236 182.948 147.775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.099 320.46C600.175 321.845 600.174 324.896 598.098 326.282L377.213 473.681C374.887 475.233 371.771 473.566 371.771 470.77V402.949C371.771 401.779 372.355 400.687 373.328 400.038L482.609 327.113C485.278 325.332 485.279 321.41 482.61 319.628L373.327 246.65C372.354 246.001 371.771 244.909 371.771 243.739V175.919C371.771 173.123 374.888 171.456 377.214 173.008L598.099 320.46Z",
    stroke: "url(#paint2_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.883 320.458C647.959 321.844 647.959 324.895 645.882 326.281L424.997 473.68C422.672 475.232 419.555 473.565 419.555 470.769V402.948C419.555 401.778 420.139 400.686 421.112 400.036L530.393 327.112C533.062 325.331 533.063 321.408 530.394 319.626L421.111 246.649C420.139 245.999 419.555 244.907 419.555 243.738V175.918C419.555 173.122 422.672 171.454 424.998 173.007L645.883 320.458Z",
    stroke: "#7788E3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.361 320.46C538.285 321.845 538.286 324.896 540.362 326.282L761.247 473.681C763.573 475.233 766.689 473.566 766.689 470.77V402.949C766.689 401.779 766.105 400.687 765.132 400.038L655.851 327.113C653.182 325.332 653.181 321.41 655.85 319.628L765.133 246.65C766.106 246.001 766.689 244.909 766.689 243.739V175.919C766.689 173.123 763.572 171.456 761.246 173.008L540.361 320.46Z",
    stroke: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.577 320.458C490.501 321.844 490.501 324.895 492.578 326.281L713.463 473.68C715.788 475.232 718.905 473.565 718.905 470.769V402.948C718.905 401.778 718.321 400.686 717.348 400.036L608.067 327.112C605.398 325.331 605.397 321.408 608.066 319.626L717.349 246.649C718.321 245.999 718.905 244.907 718.905 243.738V175.918C718.905 173.122 715.788 171.454 713.462 173.007L492.577 320.458Z",
    stroke: "#7788E3"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 385.916,
    y1: 268.129,
    x2: 342.718,
    y2: 264.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 373.056,
    y1: 266.786,
    x2: 416.257,
    y2: 270.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 603.361,
    y1: 311.428,
    x2: 371.271,
    y2: 311.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7788E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 535.099,
    y1: 311.428,
    x2: 767.189,
    y2: 311.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7788E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 627,
    height: 348,
    fill: "white",
    transform: "matrix(-1 0 0 1 627 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3422,
    height: 57.2661,
    fill: "white",
    transform: "matrix(0.995598 0.0940583 -0.0807854 0.996759 344.899 237.708)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3422,
    height: 57.2661,
    fill: "white",
    transform: "matrix(0.995594 0.0941065 -0.0807439 0.996763 353.735 238.505)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3445,
    height: 57.2641,
    fill: "white",
    transform: "matrix(-0.99559 -0.0941456 -0.0807087 0.996766 418.343 244.523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3446,
    height: 57.264,
    fill: "white",
    transform: "matrix(-0.99559 -0.0941455 -0.0807088 0.996766 409.507 243.725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.09,
    height: 309.808,
    fill: "white",
    transform: "translate(371.271 168.44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.09,
    height: 309.808,
    fill: "white",
    transform: "translate(419.055 168.438)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.09,
    height: 309.808,
    fill: "white",
    transform: "matrix(-1 0 0 1 767.189 168.44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.09,
    height: 309.808,
    fill: "white",
    transform: "matrix(-1 0 0 1 719.405 168.438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatives);
export default __webpack_public_path__ + "static/media/operatives.eb256b43.svg";
export { ForwardRef as ReactComponent };